import {Component} from "@angular/core";
import {AutocompleteSearchItemComponent} from "../autocomplete-search-item.component";
import {ListOpeCarte} from "@domain/opecarte/list-opecarte";

/**
 * Affiche un item de recherche pour OpeCarte dans la recherche avancée
 */
@Component({
    templateUrl: './ope-carte-search-item.html',
    host: { 'data-test-id': 'ope-carte-search-item' },
})
export class OpeCarteSearchItemComponent extends AutocompleteSearchItemComponent<ListOpeCarte> {

}